var _g, _rect, _g2, _rect2, _rect3, _g3, _rect4, _rect5, _g4, _rect6, _rect7, _g5, _circle, _circle2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssistantLevelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_53_2906)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 114.602 101.088)",
    fill: "url(#paint0_linear_53_2906)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 110.921 96.387)",
    fill: "url(#paint1_linear_53_2906)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_53_2906)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.3301,
    y: 101.088,
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "rotate(-60 51.3301 101.088)",
    fill: "url(#paint2_linear_53_2906)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6494,
    y: 96.387,
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "rotate(-60 47.6494 96.387)",
    fill: "black",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6494,
    y: 96.387,
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "rotate(-60 47.6494 96.387)",
    fill: "url(#paint3_linear_53_2906)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f_53_2906)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 80.9756 101.088)",
    fill: "url(#paint4_linear_53_2906)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 77.2949 96.387)",
    fill: "black",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 77.2949 96.387)",
    fill: "url(#paint5_linear_53_2906)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter3_f_53_2906)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.2578,
    y: 101.07,
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "rotate(-60 18.2578 101.07)",
    fill: "url(#paint6_linear_53_2906)"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5781,
    y: 96.3694,
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "rotate(-60 14.5781 96.3694)",
    fill: "black",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5781,
    y: 96.3694,
    width: 54.6623,
    height: 21.8649,
    rx: 10.9325,
    transform: "rotate(-60 14.5781 96.3694)",
    fill: "url(#paint7_linear_53_2906)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_f_53_2906)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66.3997,
    cy: 38.6578,
    r: 16.3987,
    fill: "#E960FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.3997,
    cy: 38.6578,
    r: 16.3987,
    fill: "url(#paint8_linear_53_2906)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.719,
    cy: 33.9569,
    r: 16.3987,
    fill: "#E960FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.719,
    cy: 33.9569,
    r: 16.3987,
    fill: "url(#paint9_linear_53_2906)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_53_2906",
    x: 61.093,
    y: 46.5066,
    width: 60.7505,
    height: 72.7559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.62097,
    result: "effect1_foregroundBlur_53_2906"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_53_2906",
    x: 44.0881,
    y: 46.5066,
    width: 60.7505,
    height: 72.7559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.62097,
    result: "effect1_foregroundBlur_53_2906"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_53_2906",
    x: 27.467,
    y: 46.5066,
    width: 60.7505,
    height: 72.7559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.62097,
    result: "effect1_foregroundBlur_53_2906"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_53_2906",
    x: 11.0159,
    y: 46.4891,
    width: 60.7505,
    height: 72.7559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.62097,
    result: "effect1_foregroundBlur_53_2906"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_53_2906",
    x: 38.759,
    y: 11.0172,
    width: 55.2817,
    height: 55.2813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.62097,
    result: "effect1_foregroundBlur_53_2906"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_2906",
    x1: 2.02447,
    y1: 10.4985,
    x2: 54.7635,
    y2: 10.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#2FC0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_2906",
    x1: 2.02447,
    y1: 10.4985,
    x2: 54.7635,
    y2: 10.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#2FC0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_53_2906",
    x1: 53.3545,
    y1: 111.586,
    x2: 106.094,
    y2: 111.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#6064FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2FC0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_53_2906",
    x1: 49.6739,
    y1: 106.886,
    x2: 102.413,
    y2: 106.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#6064FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2FC0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_53_2906",
    x1: 2.02447,
    y1: 10.4985,
    x2: 54.7635,
    y2: 10.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#6064FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#9B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_53_2906",
    x1: 2.02447,
    y1: 10.4985,
    x2: 54.7635,
    y2: 10.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#6064FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#9B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_53_2906",
    x1: 20.2823,
    y1: 111.569,
    x2: 73.0213,
    y2: 111.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729167,
    stopColor: "#FF9ABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#9B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_53_2906",
    x1: 16.6026,
    y1: 106.868,
    x2: 69.3416,
    y2: 106.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729167,
    stopColor: "#FF9ABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#9B00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_53_2906",
    x1: 55.638,
    y1: 26.1538,
    x2: 79.2137,
    y2: 50.5309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#9C01FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14E9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_53_2906",
    x1: 51.9574,
    y1: 21.4529,
    x2: 75.533,
    y2: 45.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#9C01FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14E9ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantLevelIcon);
export default __webpack_public_path__ + "static/media/assistant-level-icon.204e63d3.svg";
export { ForwardRef as ReactComponent };